import type { GoalCollectionEffort } from "@/types/agent/agent";

// Keep the levels and the default in sync with
// supabase/functions/_shared/insights/conversation-goals.ts, which writes what the genie is told.
export const DEFAULT_GOAL_COLLECTION_EFFORT: GoalCollectionEffort = "balanced";

export const GOAL_COLLECTION_OPTIONS: Array<{ effort: GoalCollectionEffort; label: string; description: string }> = [
  {
    effort: "listen_only",
    label: "Listen only",
    description: "Never asks, even for required details. Picks up only what people mention on their own.",
  },
  {
    effort: "balanced",
    label: "Balanced",
    description: "Helps first, then asks once for each missing detail. Accepts a no and never holds up a handover to a person.",
  },
  {
    effort: "thorough",
    label: "Thorough",
    description: "Keeps collecting until each detail has been asked for, and asks for required details before a handover.",
  },
];
